import classNames from "classnames";
import React from "react";
import { emotionBubbleStylesMapped } from "../../../models/interactions/EmotionBubble";

/**
 * Grid of emoji tiles for picking an emotion (Design Studio
 * `screens/bubbles-current/emotion-bubble.html` › Settings › Emotion), used in the
 * 380px settings list of both the Emotion Bubble popup and a conversation line.
 * 8 columns that shrink to fit: two rows instead of three keep those settings on
 * screen at 1080p.
 */
export default function PiEmotionGrid(props: { value: string; onChange: (emotion: string) => void }) {
  return (
    <div className="grid min-w-0 grid-cols-[repeat(8,minmax(0,1fr))] gap-1" role="radiogroup">
      {emotionBubbleStylesMapped.map((emotion) => {
        const isSelected = emotion.name === props.value;
        return (
          <button
            key={emotion.name}
            type="button"
            role="radio"
            aria-checked={isSelected}
            aria-label={emotion.displayName}
            title={emotion.displayName}
            onClick={() => props.onChange(emotion.name)}
            className={classNames(
              "grid place-items-center min-w-0 aspect-square box-border overflow-hidden p-1 rounded-[6px] border border-solid cursor-pointer outline-none transition-colors",
              "focus-visible:border-interaction-primary",
              {
                "border-interaction-primary bg-interaction-primary-selected dark:bg-[#2f4250] shadow-[inset_0_0_0_1px_var(--pi-game-blue)]":
                  isSelected,
                "border-transparent bg-interaction-primary-washed hover:border-interaction-primary-faded": !isSelected,
              }
            )}
            data-testid={`emotion-${emotion.name}`}
          >
            <img className="block w-full h-full min-w-0 object-contain" src={emotion.path} alt="" />
          </button>
        );
      })}
    </div>
  );
}
